module.exports = __webpack_public_path__ + "img/share-button-zh.b85c41df.png";